/**
 * 图表一些常用的预定义
 */

let colorList = [
  "#0DAFF4",
  "#FFDB5C",
  "#ff7c7c",
  "#fc60ac",
  "#d332eb",
  "#9f5bc4",
  "#feb64d",
  "#9287e7",
];

export { colorList };
